/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crisp_Safe_Deer_LeapInputs */

const en_crisp_safe_deer_leap = /** @type {(inputs: Crisp_Safe_Deer_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download template`)
};

const de_crisp_safe_deer_leap = /** @type {(inputs: Crisp_Safe_Deer_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage herunterladen`)
};

/**
* | output |
* | --- |
* | "Download template" |
*
* @param {Crisp_Safe_Deer_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const crisp_safe_deer_leap = /** @type {((inputs?: Crisp_Safe_Deer_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crisp_Safe_Deer_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crisp_safe_deer_leap(inputs)
	return de_crisp_safe_deer_leap(inputs)
});